import { map, zoom } from 'd3';
import React, { useState, useRef, useEffect } from 'react';
import Map, { Source, Layer, Marker } from 'react-map-gl';

const path = process.env.PUBLIC_URL

const videos = [
  { id: 1, country: '美国', src: 'https://player.vimeo.com/progressive_redirect/playback/1027033441/rendition/1080p/file.mp4?loc=external&signature=7495bd1cbb4b77f9a3bf976ff20e242c0c3658d03b68996a2afeafe9c2f1b58c', flag: '/images/flag4.svg', thumbnail: '/images/portrait4.jpg',  location: [-77.03027594451862, 38.926750906748985] },
  { id: 2, country: '台湾', src: 'https://player.vimeo.com/progressive_redirect/playback/973623107/rendition/1080p/file.mp4?loc=external&signature=a0ab5e90ce70d951bfd740bac8ba9ce6414979813f74ce5e2b21f58a0da790ee', flag: '/images/flag1.svg', thumbnail: '/images/portrait1.jpg',  location: [121.49908526381759, 25.021101130885267] },
  { id: 3, country: '南非', src: 'https://player.vimeo.com/progressive_redirect/playback/972387529/rendition/540p/file.mp4?loc=external&log_user=0&signature=4d33f8f5acaac4d8081501ffc8b5f992cd47e16a28ff031dac42c4db78c01918', flag: '/images/flag0.svg', thumbnail: '/images/portrait0.jpg',  location: [24.64808917974924, -30.076030739042476]},
  { id: 4, country: '蒙古', src: 'https://player.vimeo.com/progressive_redirect/playback/970983437/rendition/1080p/file.mp4?loc=external&log_user=0&signature=89c46d62f5893ed0a2c04bcb19a51cb5a8d28a4147140a239a580499e8e7172d', flag: '/images/flag2.svg', thumbnail: '/images/portrait2.jpg',  location: [106.85554883307047, 47.89438635838723] },
  { id: 5, country: '英国', src: 'https://player.vimeo.com/progressive_redirect/playback/976890800/rendition/1080p/file.mp4?loc=external&signature=6326a770dbcd91215adb697e9596857f5b31455bc6342b6d179753c73c26e91e', flag: '/images/flag3.svg', thumbnail: '/images/portrait3.jpg',  location: [-1.499605988042374, 51.414937937448] },
];

const Video = () => {
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const videoRef = useRef(null);
    const mapRef = useRef(null);

    const handleThumbnailClick = (src, index) => {
      mapRef.current.flyTo({
        duration: 3000,
        center: videos[index].location,
        essential: true, // this animation is considered essential with respect to prefers-reduced-motion
        bearing: 130,
        pitch: 75
      });
      handleCloseClick();
      setSelectedIndex(index);
    };

    const handleCloseClick = () => {
      if (videoRef.current) {
        videoRef.current.classList.remove('fade-in');
        videoRef.current.classList.add('fade-out');
        setSelectedVideo(null);
        videoRef.current.pause();
      }
    };

    const handleMarkerClick = (video, index) => {
      const { src } = video;
      setSelectedVideo(src);
      if (videoRef.current) {
        videoRef.current.classList.remove('fade-in');
        videoRef.current.classList.add('fade-out');
        videoRef.current.classList.remove('fade-out');
        videoRef.current.classList.add('fade-in');
      }
      // mapRef.current.flyTo({
      //   duration: 1000,
      //   center: videos[index].location,
      //   essential: true, // this animation is considered essential with respect to prefers-reduced-motion
      //   bearing: 130,
      //   pitch: 75
      // });
    };

    useEffect(() => {
      const handleLoadedData = () => {
          if (videoRef.current) {
            videoRef.current.play();
          }
      };

      if (videoRef.current && selectedVideo) {
          videoRef.current.src = selectedVideo;
          videoRef.current.addEventListener('loadeddata', handleLoadedData);
      }

      return () => {
          if (videoRef.current) {
            videoRef.current.removeEventListener('loadeddata', handleLoadedData);
          }
      };
    }, [selectedVideo]);

    const [initialViewState, setViewport] = useState({
      // center: [47.57017477344634, 106.92407194789304],
      zoom: 4,
      pitch: 0,
      bearing: 0,
      // renderWorldCopies: false,
      scrollZoom: false,
      dragPan: false,
    });

    return (
        <div className="app-container">
          <Map
            ref={mapRef}
            mapboxAccessToken="pk.eyJ1IjoidmljdG9yaWFqIiwiYSI6ImNseHAzeDE1cDA2aWcyd3BrdXI0dHd1aHAifQ.GtBMI7UbB6Q_HlVEuL9Ygg"
            {...initialViewState}
            style={{width: "100vw", height: "100vh"}}
            mapStyle="mapbox://styles/victoriaj/clxqiiqny03ca01qjev5zb440"
            onLoad={() => {
              mapRef.current.setCenter(videos[0].location);
            }}
          >
            {videos.map((marker, index) => (
              <Marker 
                key={marker.id} 
                latitude={marker.location[1]} 
                longitude={marker.location[0]}
              >
                <div className="flag-button" onClick={() => handleMarkerClick(marker, index)} style={{ opacity: selectedIndex === index ? 1 : 0 }}>
                  <img 
                    src={path + marker.flag} 
                    alt={`thumbnail-${marker.id}`} 
                    style={{ width: '120px', height: '80px', cursor: 'pointer'}} 
                  />
                  <svg viewBox="0 0 32 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_320_4670)">
                    <path d="M6 30.2892V6L25.7349 18.1446L6 30.2892Z" fill="white"/>
                    </g>
                    <defs>
                    <filter id="filter0_d_320_4670" x="0" y="0" width="31.735" height="36.2891" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="3"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_320_4670"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_320_4670" result="shape"/>
                    </filter>
                    </defs>
                  </svg>
                </div>
                {/* <div className='country__name'>{marker.country}</div> */}
              </Marker>
            ))}
          </Map>
          <div className={`video-container ${selectedVideo ? 'visible' : 'hidden'}`}>
            <video ref={videoRef} playsInline className="video-player" autoPlay preload>
              <source src={path + selectedVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button className="close-button" onClick={handleCloseClick}>×</button>
          </div>
          <div className="thumbnail-container">
            {videos.map((video, index) => (
              <div className='thumbnail-item' key={index}>
                <img
                  key={video.id}
                  src={path + video.thumbnail}
                  alt={`thumbnail-${video.id}`}
                  className={"thumbnail " + (selectedIndex === index ? 'selected' : '')}
                  onClick={() => handleThumbnailClick(video.src, index)}
                />
                <div className='thumbnail-text'>{video.country}</div>
              </div>
            ))}
          </div>
        </div>
    );
};

export default Video;